import { INDENT_TYPE as type } from "./types";
const DEFAULTS = Object.freeze({
  type,
  config: {}
});
export {
  DEFAULTS
};
//# sourceMappingURL=defaults.js.map
